<template>
  <v-app>
    <header-component v-if="requiresNavigation" class="pb-16"/>
    <router-view/>
    <footer-component v-if="requiresNavigation"/>
  </v-app>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import { Logger } from 'aws-amplify';

const logger = new Logger('app');

export default {
  name: 'App',
  components: {
    'header-component': Header,
    'footer-component': Footer,
  },
  data() {
    return {};
  },
  computed: {
    // ナビゲーション表示が必要かどうか
    requiresNavigation() {
      logger.info('requiresNavigation');
      // ログイン以外の場合
      return this.$route.name !== 'login';
    },
  },
};
</script>
